import API from '../../../../commons/api/api';
import * as actionTypes from '../actions/type';

export const initialState = {
  isProcessing: null,
  type: '',
  videoDetail: [],
  videoTemplate: [],
  videoEmoji: [],
  isProcessingTitle: null,
  isProcessingDel: false,
  isProcessingVideoRender: false,
  restrictedKeyword: [],
  videoRender: [],
};

const videoDetailReducers = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_VIDEO_DETAIL_REQUEST:
      return {
        ...state,
        isProcessing: true,
        type: action.type,
      };
    case actionTypes.GET_VIDEO_DETAIL_SUCCESS:
      return {
        ...state,
        isProcessing: false,
        videoDetail: action.payload.data,
      };

    case actionTypes.GET_VIDEO_CONTENT_TEMPLATE_REQUEST:
      return {
        ...state,
        isProcessingTemplate: true,
        type: action.type,
      };
    case actionTypes.GET_VIDEO_CONTENT_TEMPLATE_SUCCESS:
      return {
        ...state,
        isProcessingTemplate: false,
        type: action.type,
        videoTemplate: action.payload?.data?.data || [],
      };

    case actionTypes.UPDATE_VIDEO_REQUEST:
      console.log(action, 'UPDATE_VIDEO_REQUEST');
      return {
        ...state,
        isProcessingTitle: action.params.id == 'all' ? false : true,
        type: action.type,
      };
    case actionTypes.UPDATE_VIDEO_SUCCESS:
      return {
        ...state,
        isProcessingTitle: false,
        type: action.type,
      };
    case actionTypes.UPDATE_VIDEO_FAILED:
      return {
        ...state,
        isProcessingTitle: false,
        type: action.type,
      };
    case actionTypes.DELETE_VIDEO_REQUEST:
      return {
        ...state,
        isProcessingDel: true,
        type: action.type,
      };
    case actionTypes.DELETE_VIDEO_SUCCESS:
      return {
        ...state,
        isProcessing: false,
        isProcessingDel: false,
        type: action.type,
        videoDetail: [],
      };
    case actionTypes.GET_RESTRICTED_KEYWORD_REQUEST:
      return {
        ...state,
        isProcessingRestriced: true,
        type: action.type,
      };
    case actionTypes.GET_RESTRICTED_KEYWORD_SUCCESS:
      return {
        ...state,
        isProcessingRestriced: false,
        type: action.type,
        restrictedKeyword: action.payload?.data || [],
      };
    case actionTypes.GET_TIME_VIDEO_RENDER_REQUEST:
      return {
        ...state,
        isProcessingVideoRender: true,
        type: action.type,
      };
    case actionTypes.GET_TIME_VIDEO_RENDER_SUCCESS:
      return {
        ...state,
        isProcessingVideoRender: false,
        type: action.type,
        videoRender: action.payload?.data || [],
      };
    default:
      return state;
  }
};

export default videoDetailReducers;
